import { useEffect, useState } from 'react';
import { BreakfastBookingResponse } from '../response/BookingResponse';

interface UseBookingProps {
    filter: {
        property_id: string;
        base_on: string;
        start_date: string;
        end_date: string;
        room_type_id?: string;
    };
}

const useBooking = ({ filter }: UseBookingProps) => {
    const [data, setData] = useState<BreakfastBookingResponse | null>(null);
    const [isFetching, setIsFetching] = useState(false);
    const [isError, setIsError] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!filter.property_id || !filter.start_date || !filter.end_date) {
            setData(null);
            return;
        }

        setIsFetching(true);
        setIsError(false);
        setError(null);

        // Simulate API call with dummy data
        const timeout = setTimeout(() => {
            const dummyData: BreakfastBookingResponse = {
                success: true,
                data: [
                    {
                        id: "1",
                        guest_name: "John Doe",
                        booking_number: "BK001",
                        arrival_date: "2025-10-24",
                        departure_date: "2025-10-26",
                        room_number: "101",
                        room_type_name: "Deluxe Room",
                        incl_days: 2,
                        total_adults: 2,
                        total_children: 1,
                        revenue_adjustment: 50000,
                    },
                    {
                        id: "2",
                        guest_name: "Jane Smith",
                        booking_number: "BK002",
                        arrival_date: "2025-10-25",
                        departure_date: "2025-10-27",
                        room_number: "102",
                        room_type_name: "Standard Room",
                        incl_days: 2,
                        total_adults: 1,
                        total_children: 0,
                        revenue_adjustment: 25000,
                    },
                    {
                        id: "3",
                        guest_name: "Robert Johnson",
                        booking_number: "BK003",
                        arrival_date: "2025-10-23",
                        departure_date: "2025-10-28",
                        room_number: "103",
                        room_type_name: "Suite Room",
                        incl_days: 5,
                        total_adults: 2,
                        total_children: 2,
                        revenue_adjustment: 100000,
                    },
                    {
                        id: "4",
                        guest_name: "Maria Garcia",
                        booking_number: "BK004",
                        arrival_date: "2025-10-26",
                        departure_date: "2025-10-28",
                        room_number: "201",
                        room_type_name: "Deluxe Room",
                        incl_days: 2,
                        total_adults: 1,
                        total_children: 1,
                        revenue_adjustment: 40000,
                    },
                    {
                        id: "5",
                        guest_name: "David Wilson",
                        booking_number: "BK005",
                        arrival_date: "2025-10-24",
                        departure_date: "2025-10-25",
                        room_number: "202",
                        room_type_name: "Standard Room",
                        incl_days: 1,
                        total_adults: 1,
                        total_children: 0,
                        revenue_adjustment: 15000,
                    },
                ],
                total_adults: 7,
                total_children: 4,
                total_revenue_adjustment: 230000,
            };

            setData(dummyData);
            setIsFetching(false);
        }, 1000);

        return () => clearTimeout(timeout);
    }, [filter]);

    return {
        data,
        isFetching,
        isError,
        error,
    };
};

export default useBooking;
